import * as React from "react";
import PropTypes from "prop-types";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";

export default function StatusToggleSwitch({ isEditing, status, onChange }) {
  const checked = status === "published";

  const handleChange = (e) => {
    onChange(e.target.checked ? "published" : "Hidden");
  };

  if (!isEditing) {
    return (
      <Box sx={{ opacity: 0.4, pointerEvents: "none" }}>
        <FormControlLabel
          control={<Switch checked={false} />}
          label="Published (available only when editing)"
        />
      </Box>
    );
  }

  return (
    <FormControlLabel
      control={<Switch checked={checked} onChange={handleChange} />}
      label={checked ? "Published" : "Hidden"}
    />
  );
}

StatusToggleSwitch.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
